import { InvoiceEventTypeEnum, InvoiceEventViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockInvoiceEventsList: InvoiceEventViewModel[] = [
  {
    type: InvoiceEventTypeEnum.Reminded,
    date: '2021-01-01',
    amount: null,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.Reminded,
    date: '2021-02-01',
    amount: null,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.PaymentDeferral,
    date: '2021-03-01',
    amount: null,
    paymentDeferralDueDate: '2021-04-01',
  },
  {
    type: InvoiceEventTypeEnum.IncomingPayment,
    date: '2021-04-01',
    amount: 300,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.Reminded,
    date: '2021-05-01',
    amount: null,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.PaymentDeferral,
    date: '2021-06-01',
    amount: 5210,
    paymentDeferralDueDate: '2021-07-01',
  },
  {
    type: InvoiceEventTypeEnum.Disputed,
    date: '2021-07-01',
    amount: 50,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.OutgoingPayment,
    date: '2021-07-01',
    amount: -101050,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.SetOff,
    date: '2023-11-30',
    amount: null,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.ReversedPayment,
    date: '2023-11-30',
    amount: null,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.ReversedSetOff,
    date: '2024-01-30',
    amount: null,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.ReversedWriteOff,
    date: '2024-01-30',
    amount: null,
    paymentDeferralDueDate: null,
  },
  {
    type: InvoiceEventTypeEnum.WriteOff,
    date: '2024-01-30',
    amount: null,
    paymentDeferralDueDate: null,
  },
];
